import type { JobFilters } from "@js/apps/common/components/filters";
import { useFreelancerProfile } from "@js/apps/freelancer/hooks";

export const useCanSortJobsByBestMatch = (filters: Partial<JobFilters>) => {
  const freelancerProfile = useFreelancerProfile();

  // With a search phrase "Best match" orders by search relevance, which is available to everyone
  if (filters.search) {
    return true;
  }

  return !!freelancerProfile?.has_ada_embeddings;
};
